export default {
  default: () => import("/opt/dasei/source/apps/home/layouts/default.vue"),
  details: () => import("/opt/dasei/source/apps/home/layouts/details.vue")
}